export function CloseIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 16 16"
			id="Remove--Streamline-Nova"
			height={16}
			width={16}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="m8.000066666666665 8.942866666666667 6.528599999999999 6.528599999999999 0.9427999999999999 -0.9427999999999999 -6.528599999999999 -6.528599999999999 6.528599999999999 -6.528613333333333L14.528666666666666 0.528646 8.000066666666665 7.057266666666667 1.4714533333333333 0.528646 0.528646 1.4714533333333333 7.057266666666667 8.000066666666665 0.528646 14.528666666666666l0.9428073333333333 0.9427999999999999 6.528613333333333 -6.528599999999999Z"
				clipRule="evenodd"
				strokeWidth={0.6667}
			/>
		</svg>
	)
}
